// extracted by mini-css-extract-plugin
export default {"container":"dealerKitInventory_container__EDENm"};